<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-book-reader_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">コース管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'course' }">戻る</router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <td colspan="2">
              <button type="button" class="btn btn-edit" @click="edit">
                編集
              </button>
            </td>
          </tr>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">コース名</th>
            <td>{{ currentCourse.name }}</td>
          </tr>
          <tr>
            <th scope="row">コース名フリガナ</th>
            <td>{{ currentCourse.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">コースID（自動生成）</th>
            <td>{{ currentCourse.uid }}</td>
          </tr>
          <tr>
            <th scope="row">確認テスト合格点数</th>
            <td>{{ currentCourse.testPassingScore }}点</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('course/fetchCourse', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  mounted() {
    // 登録・編集の入力情報を初期化
    this.clearEditingCourse();
  },
  computed: {
    currentCourse() {
      return this.course.course;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentCourse.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentCourse.brand);
    },
    ...mapState(['course']),
  },
  methods: {
    edit() {
      this.$logger.debug('Edit Brand ID ' + this.id);
      this.$router.push({ name: 'course-id-edit', params: { id: this.id } });
    },
    ...mapActions('course', ['clearEditingCourse']),
  },
};
</script>

<style scoped>
.btn {
  margin-left: 0px;
}
.btn-edit {
  margin-right: 20px;
}
</style>
